module.exports = __webpack_public_path__ + "static/media/retailnew.f789d15d.webp";